import { UpdateSleepApneaInput } from 'types/graph';

import { SleepApneaFormValues } from '../form/types';

const buildInput = ({
  diagnosedAt,
  severity,
  everTreated,
  treatedAt,
  usesCPAPMachine,
  sleepStudyConducted,
  sleepStudyConductedAt,
  oxygenSaturation,
  apneaIndex,
  apneaHypopneaIndex,
  respiratoryDisturbanceIndex,
}: SleepApneaFormValues): UpdateSleepApneaInput => {
  const input: UpdateSleepApneaInput = {
    diagnosedAt,
    severity,
    everTreated,
    sleepStudyConducted,
  };

  if (everTreated) {
    input.treatedAt = treatedAt;
    input.usesCPAPMachine = usesCPAPMachine;
  }

  if (sleepStudyConducted) {
    input.sleepStudyConductedAt = sleepStudyConductedAt;
    input.oxygenSaturation = oxygenSaturation;
    input.apneaIndex = apneaIndex;
    input.apneaHypopneaIndex = apneaHypopneaIndex;
    input.respiratoryDisturbanceIndex = respiratoryDisturbanceIndex;
  }

  return input;
};

export default buildInput;
